export default __webpack_public_path__ + "static/media/rickandmorty2.2f9f4984.png";